import React from 'react'
import * as Types from 'types'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { compose } from 'recompose'
import {
  withJsonApiProps,
  withLayout,
  goToNextStep,
  useFlashMessages,
} from 'utils'
import { updateTenantApplication, uploadFiles } from 'api'
import { ApplicationLayout } from 'components'
import { TaxDocumentForm } from 'forms'
import { STEP, SAVE_ERROR_MESSAGE, TAX_DOCUMENT_FILE_PREFIX } from 'config'
import { isEmpty } from 'lodash'

const propTypes = {
  tenantCaseFiles: PropTypes.arrayOf(Types.file).isRequired,
  fundingProgram: PropTypes.string,
  tenantApplication: Types.tenantApplication.isRequired,
}
const defaultProps = {}

function TaxDocument({ tenantCaseFiles, tenantApplication }) {
  const { showFlashFailure } = useFlashMessages()

  const taxDocumentFiles = tenantCaseFiles.filter((file) =>
    file.name?.startsWith(TAX_DOCUMENT_FILE_PREFIX)
  )

  const initialValues = {
    taxDocument: {
      files: taxDocumentFiles,
      x1040NotAvailable: tenantApplication.x1040NotAvailable || '',
    },
  }

  return (
    <>
      <Helmet>
        <title>Tax Document</title>
      </Helmet>
      <div className="page-header">
        <h1>Tax Document</h1>
        <p>
          This program requires submission of a 1040 tax return. Please upload
          your most recently filed 1040, or provide a written explanation if you
          are unable to do so.
        </p>
      </div>
      <TaxDocumentForm
        initialValues={initialValues}
        onSubmit={async ({ taxDocument }) => {
          const { files, x1040NotAvailable } = taxDocument
          const newFiles = files.filter((file) => !file.contentDocumentId)

          if (!isEmpty(newFiles)) {
            try {
              await uploadFiles({
                files: newFiles,
                prefix: TAX_DOCUMENT_FILE_PREFIX,
              })
            } catch {
              return showFlashFailure(SAVE_ERROR_MESSAGE)
            }
          }

          try {
            await updateTenantApplication({
              x1040NotAvailable,
              currentStep: STEP.TAX_DOCUMENT.name,
            })
          } catch {
            return showFlashFailure(SAVE_ERROR_MESSAGE)
          }

          goToNextStep(STEP.HOUSEHOLD_INCOME)
        }}
      />
    </>
  )
}

TaxDocument.propTypes = propTypes
TaxDocument.defaultProps = defaultProps

export default compose(
  withJsonApiProps(),
  withLayout(ApplicationLayout)
)(TaxDocument)
